
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/wisdom",
      function () {
        return require("private-next-pages/[region]/wisdom/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/wisdom"])
      });
    }
  